<div class="footer_container">
    <div class="footer_left">
        <div class="footer_left_text">© 2023 All rights reserved</div>
    </div>
    <div class="footer_center">
        <div class="footer_center_text">Follow us on:</div>
        <div class="footer_center_text">Facebook</div>
        <div class="footer_center_text">Twitter</div>
        <div class="footer_center_text">Instagram</div>
    </div>
    <div class="footer_right">
        <div class="footer_right_text">Privacy Policy</div>
        <div class="footer_right_text">Terms of Service</div>
        <div class="footer_right_text">Contact Us</div>
    </div>
</div>